import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AllState } from '../../../store'
import { intl } from '../../../i18n'
import { SelectOption } from '../../model/selectOption'
import { MILESTONE_TARGET_WBS_ITEM_TYPES } from '../../../domain/entity/MilestoneEntity'
import { useProcessScopeOptions } from '../ProcessScopeSearchSelectPopper/useProcessScopeOptions'
import { UNRESOLVED_TARGET_LABEL } from './model'

export type MilestoneTargetOptions = {
  options: SelectOption[]
  parentMap: Record<string, string>
  optionByUuid: Map<string, SelectOption>
  isLoading: boolean
}

/**
 * マイルストーンの対象に指定できるWBS項目(工程・ワークグループ)の候補。
 * 対象欄の選択肢と、一覧・詳細に表示する対象名の解決を同じ1回の取得で賄う。
 *
 * @param enabled 閉じているダイアログから先読みしないよう、表示中のみ true にする
 */
export const useMilestoneTargetOptions = (
  enabled = true
): MilestoneTargetOptions => {
  const projectUuid = useSelector((state: AllState) => state.project.selected)
  const { options, parentMap, isLoading } = useProcessScopeOptions(
    projectUuid,
    MILESTONE_TARGET_WBS_ITEM_TYPES,
    { errorMessageId: 'milestone.error.targetFetchFailed', enabled }
  )

  const optionByUuid = useMemo(
    () => new Map(options.map(option => [option.value, option])),
    [options]
  )

  return { options, parentMap, optionByUuid, isLoading }
}

export const getMilestoneTargetLabel = (
  wbsItemUuid: string | undefined,
  optionByUuid: Map<string, SelectOption>
): { label: string; iconUrl?: string } => {
  if (!wbsItemUuid) {
    return { label: intl.formatMessage({ id: 'whole.project' }) }
  }
  const option = optionByUuid.get(wbsItemUuid)
  if (!option) return { label: UNRESOLVED_TARGET_LABEL }
  return { label: option.name, iconUrl: option.iconUrl }
}
